import { useTranslation } from 'react-i18next';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import useOtherPartyStatus from '@hooks/useOtherPartyStatus';
import useAppointmentStatus from '@hooks/useAppointmentStatus';
import { useAppointmentRoomDT } from '@hooks/useTestPatientRoom';
import { RedoOutlined } from '@ant-design/icons';
import { useVideoCallSignallingType } from '@hooks/useVideoCallSignallingType';
import React from 'react';

function PatientStatusWS() {
  const { appointment } = useSessionAppointment();
  const theirStatus = useOtherPartyStatus(appointment);
  const { controlEvents } = useAppointmentStatus(appointment);
  const patientStatus = controlEvents.filter(({ control }) => control?.partyStatus && control?.iam === 'patient');

  const patientAppointmentStatusKey: string =
    patientStatus[0]?.control.partyStatus === 'testing-webcam' ? 'testing-webcam' : theirStatus;

  return (
    {
      connected: 'Online',
      disconnected: 'Offline',
      declined: 'Declined',
      unavailable: 'Unavailable',
      'testing-webcam': 'Testing their webcam'
    }[patientAppointmentStatusKey] || 'Unknown'
  );
}

function PatientStatusDT() {
  const { t } = useTranslation('common');
  const { appointment } = useSessionAppointment();
  const { room, error } = useAppointmentRoomDT(appointment);

  if (room) {
    return room.participants.size ? <span>{t('Ready')}</span> : <span>{t('Offline')}</span>;
  }

  if (error) {
    return (
      <>
        <span>
          {t('Error: ')}
          {error.message}
        </span>
        &nbsp;&nbsp;
        <RedoOutlined onClick={() => window.location.reload()} />
      </>
    );
  }
  return <span>{t('Unavailable')}</span>;
}

export function PatientStatus() {
  const { appointment } = useSessionAppointment();
  const signallingType = useVideoCallSignallingType(appointment);

  return signallingType === 'ws' ? <PatientStatusWS /> : <PatientStatusDT />;
}
